import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import UserLayout from "layouts/user";
import SystemAdminLayout from "layouts/systemadmin";
import AuthLayout from "layouts/auth";
import ProtectedRoute from "components/auth/ProtectedRoute";
import FirstLogin from "views/auth/FirstLogin";
import Toast from "components/Toast";
import FloatingNotificationBell from "components/FloatingNotificationBell";
import { useFCM } from "hooks/useFCM";
import { useInAppNotifications } from "context/InAppNotificationContext";

const App = () => {
  const { refresh } = useInAppNotifications();
  useFCM(refresh);

  return (
    <>
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="first-login" element={<FirstLogin />} />
      <Route
        path="admin/*"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="user/*"
        element={
          <ProtectedRoute allowedRoles={["user"]}>
            <UserLayout />
          </ProtectedRoute>
        }
      />
      <Route
        path="systemadmin/*"
        element={
          <ProtectedRoute allowedRoles={["systemadmin"]}>
            <SystemAdminLayout />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/auth/sign-in-phone" replace />} />
    </Routes>
    <Toast />
    <FloatingNotificationBell />
    </>
  );
};

export default App;
